var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048",
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(398)",
    d: "m0 0h1286v2l10 3 22 9 16 8 16 10 11 9 13 12 13 17 11 18 7 14 6 21 4 20 2 19v1713l-2 23-4 22-5 21-8 16-9 16-12 17-11 12-12 10-19 12-21 10-18 6-16 5-6 3h-1274l-34-12-28-12-16-9-16-13-8-7-14-14-10-13-14-19-11-19-6-16-7-39-3-22-1-17-1-115v-106l1-214v-838l1-192v-163l1-17 6-34 4-25 5-15 13-24 15-22 12-14 13-13 11-9 10-7 17-10 24-10 11-2 4-3h2v2l10-1 7-1z",
    fill: "#F94A44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1064,350)",
    d: "m0 0h54l31 3 31 5 29 7 16 5 39 14 30 14 21 11 17 10 17 11 11 8 16 12 13 10 13 11 13 12 17 17 9 11 8 9 9 12 11 15 14 22 12 21 10 19 11 25 10 27 8 26 6 24 5 27 5 38 2 25v12l-3 37-5 36-4 22-8 29-12 36-13 31-10 19-12 22-10 16-7 10-10 13-4 6-8 9-7 10-9 9-7 9-18 18-10 8-22 18-9 7-15 11-19 12-29 16-16 8-25 11-19 7-24 7-10 3-17 5-22 4-15 2-29 3-10 1h-43l-51-6-20-3-38-10-35-11-31-13-17-9-16-8-26-16-16-11-18-14-12-11-11-9-9-9-7-6-7-8-8-8-9-11-8-9-9-12-13-18-12-19-14-25-11-22-11-27-12-35-6-21-6-27-5-29-4-37v-28l6-53 4-25 6-24 11-36 6-16 12-28 16-30 9-15 10-16 12-16 8-10 11-13 11-14 11-12 15-15 8-7 13-11 12-10 13-10 10-7 18-11 23-13 19-10 22-10 27-10 25-8 28-7 21-4 23-3z",
    fill: "#EFF0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1704,1665)",
    d: "m0 0 7 1 2 8 2 34 1 150-2 22-7 19-10 17-9 10-7 6-16 6-5 1-18 1-1174 1h-177l-32-2-8-2-7-14-4-13-2-13-1-15v-23l3-17 7-30 6-20 5-12 12-20 8-12 10-12 7-8 12-11 13-10 13-8 23-11 18-6 11-3 30-4 21-1 330-1h682l151-2 51-1 27-2z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1055,441)",
    d: "m0 0h36l31 4 26 5 22 6 20 8 20 10 14 9 11 8 12 11 10 10 9 11 11 18 8 17 8 22 3 14 1 9v9l-3 17-5 19-6 16-7 16-10 17-7 10-8 12-14 19-8 8-7 8-20 20-8 7-14 12-7 7-8 7-9 10-9 11-7 12-5 16-4 37-5 24-6 17-8 7-17 8-23 6h-14l-13-4-13-8-7-8-7-14-4-15-1-8v-28l5-28 6-23 6-17 11-20 11-16 12-14 15-15 11-9 10-10 11-9 16-14 13-13 9-11 7-10 8-13 4-11 1-6v-19l-4-12-7-11-8-9-10-7-16-8-15-4-21-3h-26l-20 3-16 8-13 10-25 25-7 8-8 8-14 10-6 3-9-1-13-3-14-6-10-7-11-11-7-14-3-11 1-12 5-20 9-20 14-19 11-12 11-11 19-13 17-10 20-9 17-6 25-5z",
    fill: "#15A6DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1063,1022)",
    d: "m0 0h17l14 4 14 7 13 11 8 8 7 10 8 16 4 12v14l-5 15-7 14-11 14-12 12-15 10-13 6-16 3-8-1-15-5-11-6-10-8-12-12-11-16-6-12-3-9-1-6 1-18 4-12 10-17 15-16 13-9 13-6z",
    fill: "#15A6DB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1714,1689)",
    d: "m0 0h1l2 31 1 38v25l1 41v31l-2 22-6 20-5 9-6 10-6 8-9 9-14 6-12 3-25 2-22 1h-88l-78-2-171-1h-688l-135 2h-126l-38-1-32-1-3-1-1-4 19 2 20 1h177l1174-1 18-1 14-4 10-5 10-10 12-20 7-19 2-22z",
    fill: "#FF615A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1683,1666)",
    d: "m0 0h14v1l-29 3-18 1-51 1-151 2h-532l-14-1v-1l140-1h37l47-1 74 1h99l25 1h94l61-1h28l66-1 47-1 51-2z",
    fill: "#FF615A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1413,1136)",
    d: "m0 0v3l-7 7-8 7-4 4h-2v2l-9 6-4 4h-2l-2 4-9 6-11 9-20 12-13 8-23 12-16 8-23 10-33 11-16 5-12 3-19 5-33 5-31 3-25 1-32-2-43-6-13-1-32-9-6-2 4-1 31 8 44 6 27 3h43l26-3 19-2 26-4 30-8 16-5 15-5 19-7 29-13 23-13 15-8 17-11 16-12 13-10 7-6 10-8 14-12z",
    fill: "#FF615A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(462,1670)",
    d: "m0 0h27l12 1h55l49 1h152l-4 2-317 1-31 2-13 2h-7v-1l21-4 40-3h9z",
    fill: "#FF615A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1811,137)",
    d: "m0 0h1l2 13 1 12v58l-1-3-2-1 1-6-1-5 1-1 1-14-2-1 2-5-5-1-4-7-2-11 1-3v-5h3v-5l-1-2 1-6 1-5z",
    fill: "#FE635C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(230,1795)",
    d: "m0 0h1l1 21 1 3h-2l2 8 2 1 1 9 3-1 6-20 1 4-6 25-2 14v23l1 15-2-4-5-31-2-26z",
    fill: "#FE6760"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1814,185)",
    d: "m0 0h1v35l-1-3-2-1 1-6-1-5 1-1 1-14-2-1z",
    fill: "#FF615A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1327,416)",
    d: "m0 0 6 2 11 7 7 5-2 1-14-9-8-5z",
    fill: "#FF615A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.658ed3e80eec4abe9e19398ae92943ae.svg";
export { ForwardRef as ReactComponent };